import { IconInfoCircleOutline } from '@iwoca/icons';
import { GetSellerCustomersResponse } from '@iwoca/lapi-client/iwocapay';
import { Spinner } from '@iwoca/orion';

import { shouldDisableModalClick } from './CustomersTable';
import { displayCurrency } from '../../../../utils/DisplayCurrency';
import { formatDate } from '../../../Fees/RateContextHeader/RateContextHeader';
import { TCustomersTableColumns } from '../../Customers.types';

export const CustomersMobileTable = ({
  sellerCustomers,
  loading,
  handleClick,
  openStatusModal,
}: {
  sellerCustomers: GetSellerCustomersResponse['data'];
  loading: boolean;
  handleClick: (
    row: TCustomersTableColumns,
    button: 'application_stage' | 'company_name',
  ) => void;
  openStatusModal: () => void;
}) => {
  if (loading)
    return (
      <div className="my-2xl flex w-full justify-center">
        <Spinner />
      </div>
    );

  return (
    <div className="grid grid-cols-[1fr] rounded-l border border-secondary-90 text-primary-90">
      {sellerCustomers.map((customer: TCustomersTableColumns) => (
        <Row
          key={customer.buyer_state_key}
          customer={customer}
          handleClick={handleClick}
          openStatusModal={openStatusModal}
        />
      ))}
    </div>
  );
};

const Row = ({
  customer,
  handleClick,
  openStatusModal,
}: {
  customer: TCustomersTableColumns;
  handleClick: (
    row: TCustomersTableColumns,
    button: 'application_stage' | 'company_name',
  ) => void;
  openStatusModal: () => void;
}) => {
  return (
    <div className="border-b border-secondary-90 p-l text-s last:border-b-0">
      <div className="flex justify-between">
        <div className="flex-col justify-between gap-xs text-primary-10">
          <div className="text-xs">
            {formatDate(customer.earliest_interacted_date, 'short')}
          </div>
          {shouldDisableModalClick(customer, 'company_name') ? (
            <div>{customer.company_name}</div>
          ) : (
            <button
              className="cursor-pointer border-none bg-transparent p-0 text-primary-40 underline"
              onClick={() => handleClick(customer, 'company_name')}
            >
              {customer.company_name}
            </button>
          )}
        </div>
        <div className="flex flex-col items-end gap-xs text-primary-10">
          <div className="flex items-center gap-s text-xs">
            {customer.spending_limit_status.label}{' '}
            <IconInfoCircleOutline
              height={15}
              width={15}
              onClick={() => openStatusModal()}
            />
          </div>
          <div>
            {customer.limit_amount === null ? (
              '----------'
            ) : (
              <div
                className={`${customer.spending_limit_status.value === 'offer_approved' && 'text-success-mid'}`}
              >
                {displayCurrency(customer.limit_amount)}
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="flex items-center gap-xs text-primary-10">
        Application stage:{' '}
        {shouldDisableModalClick(customer, 'application_stage') ? (
          <div
            className={`${
              customer.spending_limit_status.value === 'last_approved_offer' &&
              customer.limit_amount !== null &&
              'text-structure-60'
            }`}
          >
            {customer.application_stage.label}
          </div>
        ) : (
          <button
            className="cursor-pointer border-none bg-transparent p-0 text-primary-40 underline"
            onClick={() => handleClick(customer, 'company_name')}
          >
            {customer.application_stage.label}
          </button>
        )}
      </div>
    </div>
  );
};
